import React from "react";
import { TextLabel, FeedBackPage } from "../../../../shared/components";
import { Grid } from "@material-ui/core";
import { Trans } from "adapters/i18n";

const GoalPlanListEmpty = () => (
  <Grid
    container
    direction="column"
    justify="center"
    style={{
      minHeight: "60vh",
    }}
  >
    <FeedBackPage>
      <Grid container direction="column" alignItems="center">
        <img src="../images/busca.png" alt="Lupa de tela vazia" />
        <TextLabel
          id="labelFechamentoFeedBack"
          inputProps={{ "data-testid": "label-fechamento-feedBack" }}
          name="metasSemItens"
          block
          color="default2"
          customStyle={{ paddingTop: 10, textAlign: "center" }}
        >
          <Trans i18nKey="goalPlan:no-goal-plans" components={{ br: <br />, b: <b /> }} />
        </TextLabel>
      </Grid>
    </FeedBackPage>
  </Grid>
);

export default GoalPlanListEmpty;
